import { render, staticRenderFns } from "./AddQuality.vue?vue&type=template&id=33cc0bcb&scoped=true"
import script from "./AddQuality.vue?vue&type=script&lang=js"
export * from "./AddQuality.vue?vue&type=script&lang=js"
import style0 from "./AddQuality.vue?vue&type=style&index=0&id=33cc0bcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc0bcb",
  null
  
)

export default component.exports